const SET_IS_PRE_DISTRIBUTION_MODAL_SCREEN_OPEN =
  'dashboardScreen/SET_IS_PRE_DISTRIBUTION_MODAL_SCREEN_OPEN';
const SET_IS_COVER_ART_MODAL_SCREEN_OPEN =
  'dashboardScreen/SET_IS_COVER_ART_MODAL_SCREEN_OPEN';
const SET_IS_LOADING_ACCOUNT_MILESTONES =
  'dashboardScreen/SET_IS_LOADING_ACCOUNT_MILESTONES';
const SET_IS_SHOWING_REDIRECTION_CHECK_FAILED_MODAL =
  'dashboardScreen/SET_IS_SHOWING_REDIRECTION_CHECK_FAILED_MODAL';
const SET_IS_SHOWING_REDIRECTION_CHECK_SUCCEEDED_MODAL =
  'dashboardScreen/SET_IS_SHOWING_REDIRECT_CHECK_SUCCEEDED_MODAL';

const SET_IS_SHOWING_SPONSORSHIPS_TUTORIAL_MODAL =
  'dashboardScreen/SET_IS_SHOWING_SPONSORSHIPS_TUTORIAL_MODAL';
const SET_SPONSORSHIPS_TUTORIAL_MODAL_AUTOPAIR_CAMPAIGN_ID =
  'dashboardScreen/SET_SPONSORSHIPS_TUTORIAL_MODAL_AUTOPAIR_CAMPAIGN_ID';

const SET_PLAYS_DATA = 'dashboardScreen/SET_PLAYS_DATA';
const SET_TOP_PLAYED_EPISODES = 'dashboardScreen/SET_TOP_PLAYED_EPISODES';
const SET_APP_PLAYS = 'dashboardScreen/SET_APP_PLAYS';
const SET_DEVICE_PLAYS = 'dashboardScreen/SET_DEVICE_PLAYS';
const SET_DONUT_CHART_TYPE = 'dashboardScreen/SET_DONUT_CHART_TYPE';
const SET_GEO_PLAYS = 'dashboardScreen/SET_GEO_PLAYS';
const SET_DATE_RANGE = 'dashboardScreen/SET_DATE_RANGE';
const SET_SCALE = 'dashboardScreen/SET_SCALE';

const SET_IS_LOADING_PLAYS_DATA = 'dashboardScreen/SET_IS_LOADING_PLAYS_DATA';
const SET_IS_LOADING_TOP_PLAYED_EPISODES =
  'dashboardScreen/SET_IS_LOADING_TOP_PLAYED_EPISODES';

export default {
  SET_IS_COVER_ART_MODAL_SCREEN_OPEN,
  SET_IS_PRE_DISTRIBUTION_MODAL_SCREEN_OPEN,
  SET_IS_LOADING_ACCOUNT_MILESTONES,
  SET_IS_SHOWING_REDIRECTION_CHECK_FAILED_MODAL,
  SET_IS_SHOWING_REDIRECTION_CHECK_SUCCEEDED_MODAL,
  SET_PLAYS_DATA,
  SET_TOP_PLAYED_EPISODES,
  SET_APP_PLAYS,
  SET_DEVICE_PLAYS,
  SET_DONUT_CHART_TYPE,
  SET_GEO_PLAYS,
  SET_DATE_RANGE,
  SET_SCALE,
  SET_IS_LOADING_PLAYS_DATA,
  SET_IS_LOADING_TOP_PLAYED_EPISODES,
  SET_IS_SHOWING_SPONSORSHIPS_TUTORIAL_MODAL,
  SET_SPONSORSHIPS_TUTORIAL_MODAL_AUTOPAIR_CAMPAIGN_ID,
};
